import { NavLink } from "react-router-dom";
import { Radio, Tv, Instagram, Users, Music } from "lucide-react";
import { NAV } from "@/constants/testIds";

const items = [
  { to: "/", label: "Rádio", icon: Radio, testid: NAV.radio, end: true },
  { to: "/tv", label: "TV", icon: Tv, testid: NAV.tv },
  { to: "/musicas", label: "Playlist", icon: Music, testid: NAV.music },
  { to: "/instagram", label: "Instagram", icon: Instagram, testid: NAV.instagram },
  { to: "/contato", label: "Cidadão", icon: Users, testid: NAV.contact },
];

const BottomNav = () => {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-[0_-6px_24px_rgba(13,27,75,0.08)]"
      role="navigation"
      aria-label="Navegação principal"
    >
      <ul className="max-w-6xl mx-auto grid grid-cols-5">
        {items.map(({ to, label, icon: Icon, testid, end }) => (
          <li key={to}>
            <NavLink
              to={to}
              end={end}
              data-testid={testid}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center py-2.5 gap-0.5 transition-colors ${
                  isActive
                    ? "text-[var(--fi-red)]"
                    : "text-gray-500 hover:text-[var(--fi-blue)]"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <Icon className="w-5 h-5" strokeWidth={isActive ? 2.5 : 1.9} />
                  <span
                    className={`text-[10px] sm:text-[11px] uppercase tracking-wider font-bold ${
                      isActive ? "text-[var(--fi-red)]" : ""
                    }`}
                  >
                    {label}
                  </span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default BottomNav;
